import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Flex } from '@chakra-ui/react';
import 'handsontable/dist/handsontable.full.min.css';

import SubmitButton from '../../../../CommonComponents/SubmitButton';
import ImageModal from '../../../../FunctionalComponents/Modal/ImageModal';
import { DataNotFound } from '../../../../CommonComponents/DataNotFound';
import FormLoader from '../../../../CommonComponents/FormLoader';

import ManMadeHeritageTable from './ManMadeHeritageTable';
import EditModal from './EditModal';
import { useManMadeHeritageData, useEditModal, useTableSave } from './hooks';
import { tableStyles } from './styles';

const ManMadeHeritage = ({ onCountLoad }) => {
  const { alias } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImageSrc, setModalImageSrc] = useState("");

  const hotRef = useRef(null);

  // Custom hooks
  const {
    landingPageData,
    tableData,
    isLoading,
    refreshData
  } = useManMadeHeritageData(alias);

  useEffect(() => {
    if (!isLoading) onCountLoad?.(tableData?.length ?? 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData, isLoading]);

  const {
    editModalOpen,
    editData,
    isEditLoading,
    isEditSubmitting,
    formRef,
    setFormRef,
    fetchRecordData,
    handleEditSubmit,
    closeModal
  } = useEditModal(alias, refreshData);

  const { isSubmitting, saveClickCallback, handleDelete } = useTableSave(alias, landingPageData, refreshData);

  const openImageModal = (src) => {
    setModalImageSrc(src);
    setIsModalOpen(true);
  };

  const closeImageModal = () => {
    setIsModalOpen(false);
    setModalImageSrc("");
  };

  const handleEditClick = (recordAlias) => {
    fetchRecordData(recordAlias);
  };

  const handleSaveClick = () => {
    const hot = hotRef.current?.hotInstance;
    if (hot) {
      const data = hot.getData();
      saveClickCallback(data);
    }
  };

  return (
    <Box>
      <style>{tableStyles}</style>
      {isLoading ? (
        <FormLoader />
      ) : (
        <>
          {landingPageData?.data?.length > 0 ? (
            <>
              <Flex justifyContent="flex-start" mb={4}>
                <SubmitButton isLoading={isSubmitting} onClick={handleSaveClick} />
              </Flex>
              
              <ManMadeHeritageTable
                ref={hotRef}
                tableData={tableData}
                onEditClick={handleEditClick}
                onImageClick={openImageModal}
                onDeleteClick={handleDelete}
              />
              
              <ImageModal 
                isModalOpen={isModalOpen} 
                closeImageModal={closeImageModal} 
                modalImageSrc={modalImageSrc} 
              />
              
              <Flex justifyContent="flex-start" mt={4}>
                <SubmitButton isLoading={isSubmitting} onClick={handleSaveClick} />
              </Flex>
            </>
          ) : (
            <DataNotFound />
          )}
        </>
      )}

      <EditModal
        isOpen={editModalOpen}
        onClose={closeModal}
        editData={editData}
        isEditLoading={isEditLoading}
        isEditSubmitting={isEditSubmitting}
        formRef={formRef}
        setFormRef={setFormRef}
        onSubmit={handleEditSubmit}
      />
    </Box>
  );
};

export default ManMadeHeritage;
